import { Component, OnInit } from '@angular/core';
import { ObjectSelect } from 'src/app/shared/model/models';
import { ObjectenService } from 'src/app/shared/dataservices/objecten.service';

@Component({
  selector: 'app-object',
  templateUrl: './object.component.html',
  styleUrls: ['./object.component.less']
})
export class ObjectComponent implements OnInit {

  data = [];
  objectid = 0;
  record = 0;

  constructor(private objectService: ObjectenService) { }

  ngOnInit() {
  }


  selectionChanged(selection: ObjectSelect) {
    this.objectService.getObjecten(selection).subscribe(data => {
      this.data = data;
      if (data.length == 0) {
        this.objectid = null;
        return;
      }
      this.objectid = data[0].ID;
    })

  }

  objectChanged(data) {
    this.objectid = data.ID;
    this.record = data.record;

  }

}
